import './App.css';

function App() {
  return (
    <div className="App">
      <h1>M4 Tech Edu</h1>
    </div>
  );
}

export default App;
